import { useLanguage } from "@/components/language-provider";
import { LegalLayout } from "@/components/legal-layout";

export default function License() {
  const { language } = useLanguage();

  if (language === "en") {
    return (
      <LegalLayout title="License Agreement">
        <p className="text-muted-foreground text-sm mb-8">Last updated: January 2026</p>
        <h2>1. License Grant</h2>
        <p>FillSign grants you a non-exclusive, non-transferable, revocable license to use the Service in accordance with these terms and your subscription plan.</p>
        <h2>2. Restrictions</h2>
        <p>You may not reverse engineer, decompile, or disassemble any part of the Service. Redistribution of the software or API without written consent is prohibited.</p>
        <h2>3. Intellectual Property</h2>
        <p>All rights, title, and interest in the Service, including the AI models, user interface, and branding, belong to FillSign. Your content remains your property.</p>
        <h2>4. Dynamics 365 Plugin</h2>
        <p>The FillSign plugin for Microsoft Dynamics 365 is licensed separately. Its use requires an active FillSign subscription and a valid Dynamics 365 license.</p>
        <h2>5. API Usage</h2>
        <p>API access is granted per your subscription plan. Excessive or abusive use may result in rate limiting or suspension.</p>
        <h2>6. Termination</h2>
        <p>This license terminates automatically upon cancellation of your subscription or violation of these terms.</p>
        <h2>7. Contact</h2>
        <p>For licensing questions, contact us at legal@fillsign.com.</p>
      </LegalLayout>
    );
  }

  return (
    <LegalLayout title="Acordo de Licença">
      <p className="text-muted-foreground text-sm mb-8">Última atualização: Janeiro de 2026</p>
      <h2>1. Concessão de Licença</h2>
      <p>O FillSign concede a você uma licença não exclusiva, intransferível e revogável para usar o Serviço conforme estes termos e seu plano de assinatura.</p>
      <h2>2. Restrições</h2>
      <p>Você não pode fazer engenharia reversa, descompilar ou desmontar qualquer parte do Serviço. A redistribuição do software ou API sem consentimento por escrito é proibida.</p>
      <h2>3. Propriedade Intelectual</h2>
      <p>Todos os direitos, títulos e interesses no Serviço, incluindo modelos de IA, interface e marca, pertencem ao FillSign. Seu conteúdo permanece sua propriedade.</p>
      <h2>4. Plugin Dynamics 365</h2>
      <p>O plugin FillSign para Microsoft Dynamics 365 é licenciado separadamente. Seu uso requer uma assinatura ativa do FillSign e uma licença válida do Dynamics 365.</p>
      <h2>5. Uso da API</h2>
      <p>O acesso à API é concedido conforme seu plano de assinatura. Uso excessivo ou abusivo pode resultar em limitação ou suspensão.</p>
      <h2>6. Rescisão</h2>
      <p>Esta licença é rescindida automaticamente com o cancelamento da assinatura ou violação destes termos.</p>
      <h2>7. Contato</h2>
      <p>Para questões de licenciamento, entre em contato pelo email legal@fillsign.com.</p>
    </LegalLayout>
  );
}
